export default __webpack_public_path__ + "static/media/edit-icon.6be76803.svg";